import { useCallback } from 'react'
import TourTripScreen from '../../(tabs)/tours/trip/[bookingId]'
import { useLocalSearchParams } from 'expo-router'
import { seedToursTrip } from '../../../preview/seed'
import { PreviewSeedBoundary } from '../../../preview/PreviewSeedBoundary'

export default function PreviewTourTripRoute() {
  const params = useLocalSearchParams<{ bookingId?: string | string[] }>()
  const bookingId = Array.isArray(params.bookingId)
    ? (params.bookingId[0] ?? 'tourbook_preview_live')
    : (params.bookingId ?? 'tourbook_preview_live')
  const viewerRole = bookingId.includes('operator') ? 'operator' : 'organizer'
  const seed = useCallback(() => seedToursTrip(bookingId, viewerRole), [bookingId, viewerRole])

  return (
    <PreviewSeedBoundary seed={seed} seedKey={`trip:${bookingId}:${viewerRole}`}>
      <TourTripScreen />
    </PreviewSeedBoundary>
  )
}
